import React, { useState } from 'react';
import { Grid } from '@exxonmobil/react-unity';
import { CostValidation, OverallValidation, VolumeValidation } from '../../common/types/TrendsTypes';
import MainCard from '../../common/components/MainCard';
import DomainCostPieChart from './DomainCostPieChart';
import DomainVolumeChart from './DomainVolumeChart';
import DomainCostChart from './DomainCostChart';
import DomainChart from './DomainChart';
import { Period } from './TrendsFieldSet';
import costButton from './CostButton';

interface Props {
  overall: OverallValidation;
  overallIsLoading: boolean;
  overallError: string;
  overallOnRefresh: () => void;
  volume: VolumeValidation;
  volumeIsLoading: boolean;
  volumeError: string;
  volumeOnRefresh: () => void;
  cost: CostValidation[];
  costIsLoading: boolean;
  costError: string;
  costOnRefresh: () => void;
  domainName: string;
  is30Days: boolean;
  timePeriod: Period;
}

const ChartGroup = ({
  overall,
  overallIsLoading,
  overallError,
  overallOnRefresh,
  volume,
  volumeIsLoading,
  volumeError,
  volumeOnRefresh,
  cost,
  costIsLoading,
  costError,
  costOnRefresh,
  domainName,
  is30Days,
  timePeriod
}: Props) => {
  const isAllDomain = domainName === 'All Domain';
  const extendedVolumeGrid = isAllDomain ? '2-up' : '1-2-1';
  const isProd = process.env.REACT_APP_BUILD === 'prd';
  const [subscription, setSubscription] = useState('All');
  return (
    <>
      <MainCard
        title="Overall Domain"
        kicker={domainName}
        info={
          <div>
            Data collected and displayed on a daily basis based on actual utilization.
            <br />
            Note: Consumers number is unique consumers.
          </div>
        }
        footer={
          <DomainChart data={overall} isLoading={overallIsLoading} error={overallError} onRefresh={overallOnRefresh} />
        }
      />
      <Grid variant={extendedVolumeGrid}>
        <Grid.Item>
          <MainCard
            title="Volume"
            kicker={domainName}
            footer={
              <DomainVolumeChart
                data={volume}
                isLoading={volumeIsLoading}
                error={volumeError}
                onRefresh={volumeOnRefresh}
              />
            }
          />
        </Grid.Item>
        {isAllDomain && (
          <Grid.Item>
            <MainCard
              title="Azure Subscription Cost"
              kicker={is30Days ? 'Cost by service [Last Month]' : 'Cost by service'}
              icon={isProd ? costButton({ subscription, setSubscription }) : ''}
              footer={
                <DomainCostPieChart
                  data={cost}
                  isLoading={costIsLoading}
                  error={costError}
                  onRefresh={costOnRefresh}
                  timePeriod={timePeriod}
                  subscription={subscription}
                />
              }
            />
          </Grid.Item>
        )}
      </Grid>
      {isAllDomain && !is30Days && (
        <MainCard
          title="Azure Subscription Cost Trend"
          kicker="Cost on monthly basis"
          icon={isProd ? costButton({ subscription, setSubscription }) : ''}
          info="Azure Subscription Cost collected at the end of month"
          footer={
            <DomainCostChart
              data={cost}
              isLoading={costIsLoading}
              error={costError}
              onRefresh={costOnRefresh}
              subscription={subscription}
            />
          }
        />
      )}
    </>
  );
};

export default ChartGroup;
